define(function(require) {
	const data_item_tpl = require('../templates/t_itv_menu_item.hbs');
	return Marionette.ItemView.extend({
		events:{
			'click':'actionItemClicked'
		},
		template:data_item_tpl,
		tagName:'li',
		initialize:function(options){
		},
		actionItemClicked:function(e){
			if(e){
				e.preventDefault();
				e.stopPropagation();
			}
			//console.log('option clicked');
			//trigger method on parent view
			this.trigger('actionItemClicked',this.model.get('optionValue'));
		}
	});
});
